// @flow
import React, { type Node } from 'react';
import throttle from 'lodash/throttle';

const THROTTLE_TIMEOUT = 200;

type ScrollContainer = {
  clientHeight: number,
  scrollHeight: number,
  scrollTop: number,
};

export const scrollPositionIsNearBottom = (
  { scrollTop, clientHeight, scrollHeight }: ScrollContainer,
  customScrollBuffer?: (number) => number,
) => {
  const scrollBottom = scrollTop + clientHeight;
  const scrollBuffer = customScrollBuffer ? customScrollBuffer(clientHeight) : clientHeight * 2;
  return scrollBottom + scrollBuffer > scrollHeight;
};

type Props = {|
  children: ({
    onScroll: () => void,
    setRef: (ref: ?HTMLDivElement) => void,
  }) => Node,
  fetchMore?: () => void,
  scrollBuffer?: (clientHeight: number) => number,
|};

export default class ScrollFetcher extends React.PureComponent<Props> {
  componentDidMount() {
    setTimeout(this.fetchMoreIfNecessary);
  }

  componentDidUpdate() {
    this.fetchMoreIfNecessary();
  }

  setContainerRef = (ref: ?HTMLDivElement) => {
    this.containerRef = ref;
  };

  containerRef: ?HTMLDivElement;

  fetchMoreIfNecessary = throttle(() => {
    const { fetchMore, scrollBuffer } = this.props;
    if (
      fetchMore &&
      this.containerRef &&
      scrollPositionIsNearBottom(this.containerRef, scrollBuffer)
    ) {
      fetchMore();
    }
  }, THROTTLE_TIMEOUT);

  render() {
    const { children } = this.props;
    return children({ onScroll: this.fetchMoreIfNecessary, setRef: this.setContainerRef });
  }
}
